import { ConfirmationEmail } from "./EmailsComponents/ConfirmationEmail.tsx"
import { EmailsMenu } from "./EmailsComponents/EmailsMenu.tsx"
import { CancellationEmail } from "./EmailsComponents/CancellationEmail.tsx"
import { RemindersEmail } from "./EmailsComponents/RemindersEmail.tsx"
import { FollowUpEmail } from "./EmailsComponents/FollowUpEmail.tsx"
import { useState } from "react"
import { PreCallNotificationEmail } from "./EmailsComponents/PreCallNotificationEmail.tsx"

export type EmailsType = "Email Confirmation" | "Email Cancellation" | "Email Reminders" | "Email Follow-up" | "Pre-Call Email"


export function EmailPromptEditor() {
  const [type, setType] = useState<EmailsType>("Email Confirmation")


  const Editors: Record<EmailsType, React.ReactNode> = {
    "Email Confirmation": <ConfirmationEmail />,
    "Email Cancellation": <CancellationEmail />,
    "Email Follow-up": <FollowUpEmail />,
    "Email Reminders": <RemindersEmail />,
    "Pre-Call Email": <PreCallNotificationEmail />,
  }
  return (
    <>
      <div className="flex items-center justify-between my-6">
        <div>
          <h2 className="text-2xl font-bold">Emails Notifications Settings</h2>
          <p className="text-muted-foreground">
            Customize your emails notifications
          </p>
        </div>
      </div>
      <div className="grid grid-cols-4 gap-10 ">
          <EmailsMenu type={type} setType={setType} />
          {Editors[type]}
      </div>

    </>
  )
}